import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider } from "@tendercuts/http";
import { DriverProfile } from "@tendercuts/models";

@Injectable()
export class DriverProfileSearchService extends BaseGetProvider<DriverProfile> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices,
  ) {
    super(http);
    this.delegate = this;
  }

  preProcessResponse(response: any): Array<any> {
    return response.results;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof DriverProfile {
    return DriverProfile;
  }

  get endpoint(): string {
    return this.endpointService.driverProfile();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(
    searchValue: string,
  ): {
    mobile_number: string;
  } {
    const params: {
      mobile_number: string;
    } = {
      mobile_number: searchValue,
    };

    return params;
  }
}
